import React from 'react';
import { motion } from 'framer-motion';

const genres = [
  "Smart Money", "Breakouts", "Liquidity Grabs", "Options", 
  "Forex", "Crypto", "Volume Analysis", "Risk Management", 
  "Trend Structure", "Moneyflow", "Institutional Logic", "Conviction Trading"
];

const GenrePills = () => {
  return (
    <div className="w-full py-16 bg-[#0a0a0a] relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-12 relative z-10">
        <h3 className="text-[18px] md:text-[22px] font-bold text-white tracking-wide flex items-center mb-8">
          Explore Topics
        </h3>
        
        <div className="flex flex-wrap gap-3 md:gap-4">
          {genres.map((genre, index) => {
            // Create a slow floating effect with different delays
            const floatAnimation = {
              y: [0, -8, 0],
              transition: {
                duration: 4 + Math.random() * 2,
                repeat: Infinity,
                ease: "easeInOut",
                delay: Math.random() * 2
              }
            };

            return (
              <motion.div
                key={genre}
                animate={floatAnimation}
                whileHover={{ scale: 1.05, y: -5, transition: { duration: 0.2 } }}
                className="px-5 py-2.5 rounded-full bg-[#151515] border border-white/5 text-gray-300 font-medium text-sm hover:text-white hover:border-rocket/40 hover:shadow-[0_0_20px_rgba(255,102,0,0.15)] hover:bg-[#1a1a1a] transition-colors cursor-pointer backdrop-blur-sm"
              >
                {genre}
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default GenrePills;